import { useState, useEffect } from "react";

export const  usePermissionStatus=()=> {

    if (!(process.env.NEXT_PUBLIC_ENVIRONMENT === "production"))
      return {
        notification: false,
        location: true,
        camera: false,
      };

  const [permissions, setPermissions] = useState({
    notification: false,
    location: false,
    camera: false,
  });

  useEffect(() => {
    async function checkPermissions() {
      const results = {};

      // Notification permission
      if ("Notification" in window) {
        results.notification = Notification.permission === "granted";
      } else {
        results.notification = false;
      }

      // Location permission
      if (navigator.permissions) {
        try {
          const locStatus = await navigator.permissions.query({ name: "geolocation" });
          results.location = locStatus.state === "granted";
          locStatus.onchange = () => {
            setPermissions((prev) => ({ ...prev, location: locStatus.state === "granted" }));
          };
        } catch {
          results.location = false;
        }
      } else {
        results.location = false;
      }

      // Camera permission
      if (navigator.permissions) {
        try {
          const camStatus = await navigator.permissions.query({ name: "camera" });
          results.camera = camStatus.state === "granted";
          camStatus.onchange = () => {
            setPermissions((prev) => ({ ...prev, camera: camStatus.state === "granted" }));
          };
        } catch {
          results.camera = false;
        }
      } else {
        results.camera = false;
      }

      setPermissions(results);
    }

    checkPermissions();
  }, []);

  return permissions;
}

